import { createSlice } from "@reduxjs/toolkit";

const routesSlice = createSlice({
  name: "routes",
  initialState: {
    routesList: {
      data: [],
      total: 0,
    },
  },
  reducers: {
    setRoutesList: (state, action) => {
      state.routesList = action.payload;
    },
  },
});

export const { setRoutesList } = routesSlice.actions;
export default routesSlice.reducer;